import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, Package } from 'lucide-react';

const ShopSellers = ({ styles, sellers = [] }) => {
  const formatShopName = (shopName) => {
    if (!shopName) return 'unnamed-shop';
    return shopName.toLowerCase().replace(/\s+/g, '-');
  };

  if (!sellers || sellers.length === 0) {
    return (
      <div className="w-full p-4 text-center text-white">
        No stores available at the moment.
      </div>
    );
  }

  return (
    <div
      className={`${
        styles === 'grid'
          ? 'grid-cols-3 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid'
          : 'w-[400px] md-lg:w-auto grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1'
      } gap-3`}
    >
      {sellers.map((seller, i) => {
        // Add protective check for seller object
        if (!seller) return null;

        // Safe access to shopInfo
        const shopInfo = seller.shopInfo || {};
        const shopName = shopInfo.shopName || 'Unnamed Shop';
        const description = shopInfo.description || 'No description available.';
        
        return (
          <div
            key={i}
            className="bg-[#070707] group transition-all duration-500 hover:shadow-md cursor-pointer"
          >
            <div className="relative overflow-hidden">
              {seller.verification?.verified && (
                <div className="flex justify-center items-center absolute text-black py-[2px] px-4 rounded-full bg-[#FFE11B] font-semibold text-s left-2 top-2">
                  Verified <BadgeCheck size={18} className="ml-2" />
                </div>
              )}

              <Link 
                to={`/${shopName}`}
                className="block"
              >
                <img
                  className="sm:w-full w-full h-[240px] nex_img_cover"
                  src={seller.image || '/default-shop-image.png'}
                  alt={`${shopName} store`}
                />
              </Link>
            </div>

            <div className="py-3 text-slate-white px-2">
              <div className="flex justify-between items-center gap-3 p-2">
                <h2 className="text-lg font-bold">{shopName}</h2>
              </div>

              <div className="p-2 text-gray-300">
                {description.length > 100
                  ? `${description.slice(0, 100)}...`
                  : description}
              </div>

              <div className="p-2 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Package size={20} />
                  <span>{seller.productCount || 0} Products</span>
                </div>
                <Link
                  to={`/${shopName}`}
                  className="bg-white nex_button_main font-semibold hover:bg-[#FFE11B] hover:text-black px-4 py-2 flex items-center"
                >
                  Visit store
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ShopSellers;